import {
  jb_mail_icon_css_default
} from "./chunk.SE3OJZJW.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.4CJNI2ZH.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/icons/jb-mail-icon/jb-mail-icon.ts
var JbMailIcon = class extends Icon(i) {
  render() {
    return b`<svg
      fill="currentColor"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 3C16.1046 3 17 3.89543 17 5V13C17 14.1046 16.1046 15 15 15H3C1.89543 15 1 14.1046 1 13V5C1 3.89543 1.89543 3 3 3H15ZM2.299 5.007L2.3 13C2.3 13.3544 2.56334 13.6473 2.90501 13.6936L3 13.7H15C15.3544 13.7 15.6473 13.4367 15.6936 13.095L15.7 13V5.034L9.37049 9.52994C9.17265 9.67045 8.91587 9.68759 8.70369 9.58155L8.61579 9.52856L2.299 5.007ZM14.489 4.299H3.544L8.995 8.201L14.489 4.299Z"
      />
    </svg>`;
  }
};
JbMailIcon.styles = [reset_css_default, jb_mail_icon_css_default];
JbMailIcon = __decorateClass([
  customElement("jb-mail-icon")
], JbMailIcon);

export {
  JbMailIcon
};
